module.exports = __webpack_public_path__ + "img/img14.ce07a19b.png";